import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartCtx = createContext(null);
const KEY = "tbrand_cart";
export const FREE_SHIP = 2999;
export const SHIP_FEE = 0;

const load = () => {
  try {
    const v = JSON.parse(localStorage.getItem(KEY));
    return Array.isArray(v) ? v : [];
  } catch {
    return [];
  }
};

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(load);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const api = useMemo(() => {
    const add = (p, size, qty = 1) =>
      setItems((cur) => {
        const i = cur.findIndex((x) => x.slug === p.slug && x.size === size);
        if (i >= 0) return cur.map((x, k) => (k === i ? { ...x, qty: Math.min(10, x.qty + qty) } : x));
        return [...cur, { slug: p.slug, name: p.name, price: p.price, image: p.image, color: p.color, size, qty }];
      });
    const setQty = (slug, size, qty) =>
      setItems((cur) => cur.flatMap((x) => (x.slug === slug && x.size === size ? (qty < 1 ? [] : [{ ...x, qty: Math.min(10, qty) }]) : [x])));
    const subtotal = items.reduce((s, x) => s + x.price * x.qty, 0);
    const count = items.reduce((s, x) => s + x.qty, 0);
    const shipping = subtotal === 0 || subtotal >= FREE_SHIP ? 0 : SHIP_FEE;
    return { items, open, setOpen, add, setQty, clear: () => setItems([]), subtotal, count, shipping, total: subtotal + shipping };
  }, [items, open]);

  return <CartCtx.Provider value={api}>{children}</CartCtx.Provider>;
};

export const useCart = () => useContext(CartCtx);
